/**
 * Active SDX theme detection.
 *
 * The navigation engine compares the current active theme against
 * the theme reported by each partial response. A mismatch means the
 * shells differ (regions, attached libraries, CSS) and the only
 * safe action is a full browser load. SdxEngineHooks writes
 * drupalSettings.sdx.activeTheme on every SDX engine page and the
 * server echoes it in every partial envelope, so a null here means
 * the page is not being rendered by the SDX engine (e.g., a Twig
 * admin page) and must also fall back to a full load.
 */

export function currentActiveTheme(): string | null {
  const sdx = drupalSettings.sdx as { activeTheme?: unknown } | undefined;
  const theme = sdx?.activeTheme;
  return typeof theme === 'string' && theme.length > 0 ? theme : null;
}
